
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/multiselect/templates/items"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='nano'>\n  <div class='nano-content' aria-label='Workspaces' role='listbox'>\n    <ul class='multiselect_list'></ul>\n  </div>\n</div>\n<div class='multiselect_footer'>\n  <div class='btn btn--primary' aria-labelledby='btn-label' role='button' tabindex='0'>\n    <div class='btn-label'>\n      Add This Workspace\n    </div>\n  </div>\n</div>\n";
},"useData":true});
    }).call(this);
  